import { TOGGLE_MENU } from '../actions/constants'

const initialState = {
  toggleMenu: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MENU:
      return {
        ...state,
        toggleMenu: !state.toggleMenu,
      }

    default:
      return {
        ...state,
      }
  }
}
